import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { motion } from "framer-motion";

gsap.registerPlugin(ScrollTrigger);

const ExploreSection = () => {
  useEffect(() => {
    // You can add GSAP scroll animations here if needed
  }, []);

  const designs = [
    { title: "Modern Kitchen", img: "/assets/Images/5l.webp" },
    { title: "Rustic Charm", img: "/assets/Images/6l.webp" },
    { title: "Elegant Design", img: "/assets/Images/7l.webp" },
    { title: "Urban Minimal", img: "/assets/Images/8l.webp" },
    { title: "Contemporary Space", img: "/assets/Images/9l.webp" },
    { title: "Classic Aesthetic", img: "/assets/Images/10l.webp" },
  ];

  return (
    <section
      className="explore-section py-16 bg-white"
      aria-labelledby="explore-title"
    >
      <div className="mx-auto px-6 flex flex-col items-center justify-center">
        <header className="text-center mb-8">
          <h1
            id="explore-title"
            className="text-orange-600 font-medium text-lg mb-4 uppercase"
          >
            Our Project
          </h1>
          <h2 className="text-5xl font-bold text-black mb-6">
            Explore Our Kitchen Designs
          </h2>
          <p className="w-full sm:w-2/3 text-gray-600 mx-auto">
            Discover stunning kitchen designs that blend functionality with
            aesthetic appeal. From modern to classic, our curated projects
            showcase expert craftsmanship and innovative design concepts.
          </p>
        </header>
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full lg:w-2/3"
          role="list"
        >
          {designs.map((design, index) => (
            <motion.article
              key={index}
              className="design-card relative rounded-lg shadow-lg transform transition duration-300 hover:scale-105"
              whileHover={{ scale: 1.05 }}
              role="listitem"
            >
              <img
                src={design.img}
                alt={`${design.title} - premium kitchen design`}
                className="rounded-lg w-full h-72 object-cover"
              />
              <div
                className="absolute inset-0 bg-gray-600 bg-opacity-75 opacity-0 flex items-center justify-center transition-opacity duration-300 hover:opacity-100 rounded-lg"
                role="button"
                aria-label={`Learn more about ${design.title}`}
              >
                <h3 className="text-white text-xl font-bold">{design.title}</h3>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExploreSection;
